import { cva } from '@vizit/theme';

const containerClasses = cva({
  base: 'flex flex-col justify-between px-8 pb-3 pt-6 h-[163px] w-[241px] transition-all duration-[350ms]',
  variants: {
    state: {
      default: 'bg-primary',
      focused: 'bg-primary shadow-lg',
      disabled: '',
    },
  },
  defaultVariants: {
    state: 'default',
  },
});

function getWarningColor(isDisabled: boolean): string {
  return isDisabled ? 'text-warning-200' : 'text-fg-warning-secondary';
}

export { containerClasses, getWarningColor };
